module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_team_balancing-2b40c4fafff2f91ae8ddf885f9ab405a.png";